import { useMarkAllAsRead, useNotifications } from '@app/data/Notifications';
import { useMemo } from 'react';

export default function useNotificationsList() {
	const {
		data,
		isError: isNotificationsError,
		isLoading: isNotificationsLoading,
		refetch,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
	} = useNotifications();

	const notifications = useMemo(
		() => data?.pages.flatMap((page) => page.data) ?? [],
		[data]
	);

	const unseenNotificationsCount = useMemo(
		() => data?.pages[0]?.unread_count ?? 0,
		[data?.pages]
	);

	const isNotificationUnseen = useMemo(
		() => unseenNotificationsCount > 0,
		[unseenNotificationsCount]
	);

	const isNotificationsEmpty = useMemo(
		() => notifications.length === 0,
		[notifications]
	);

	const { doMarkAllAsRead, isLoading: isMarkAllAsReadLoading } =
		useMarkAllAsRead({
			onSuccess: refetch,
		});

	const isMarkAllAsReadDisabled = useMemo(
		() =>
			isMarkAllAsReadLoading || !isNotificationUnseen || isNotificationsEmpty,
		[isMarkAllAsReadLoading, isNotificationUnseen, isNotificationsEmpty]
	);

	return {
		notifications,
		isNotificationsLoading,
		isNotificationsError,
		unseenNotificationsCount,
		isNotificationUnseen,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
		doMarkAllAsRead,
		isNotificationsEmpty,
		isMarkAllAsReadDisabled,
	};
}
